const DEFAULT_OPTIONS = [{ value: '1', label: 'N/A' }];

const GROUP_TRAINING_TYPE = [
  ...DEFAULT_OPTIONS,
  { value: '2', label: 'Outbound' },
  { value: '3', label: 'Seminar' },
  { value: '4', label: 'Training' },
  { value: '5', label: 'Workshop' },
  { value: '6', label: 'Event' }
];

const LEVEL_OF_TRAINING = [
  ...DEFAULT_OPTIONS,
  { value: '2', label: 'Basic' },
  { value: '3', label: 'Intermediate' },
  { value: '4', label: 'Advance' }
];

const LEARNING_FORMAT = [
  ...DEFAULT_OPTIONS,
  {
    value: '2',
    label: 'Streaming'
  },
  {
    value: '3',
    label: 'Fundamental'
  }
];

const LEARNING_TYPE = [
  ...DEFAULT_OPTIONS,
  {
    value: '2',
    label: 'External'
  },
  {
    value: '3',
    label: 'In-House'
  },
  {
    value: '4',
    label: 'Internal'
  }
];

const MODE_OF_DELIVERY = [
  ...DEFAULT_OPTIONS,
  {
    value: '2',
    label: 'Virtual Conference'
  },
  {
    value: '3',
    label: 'Face to Face'
  },
  {
    value: '4',
    label: 'Blended Learning'
  },
  {
    value: '5',
    label: 'Self Learning'
  },
  {
    value: '6',
    label: 'On The Job Training (OJT)'
  },
  {
    value: '7',
    label: 'Hybrid Learning'
  },
  {
    value: '8',
    label: 'Experiential Learning'
  }
];

const PASSING_FORMULA = [
  { value: '1', label: 'N/A', description: 'N/A' },
  {
    value: '2',
    label: 'Passing Formula 1',
    description: 'Kelulusan: Kehadiran &gt;=85%'
  },
  {
    value: '3',
    label: 'Passing Formula 2',
    description: 'Kelulusan: Kehadiran &gt;=85% dan Nilai Post Test =70'
  },
  {
    value: '4',
    label: 'Passing Formula 3',
    description:
      'Kelulusan: Kehadiran &gt;=85%, jumlah nilai post test + alp (30% post test + 70% alp) = 70'
  },
  {
    value: '5',
    label: 'Passing Formula 4',
    description: 'Kelulusan: kehadiran &gt;=85%, Post test 75, ALP 75'
  },
  {
    value: '6',
    label: 'Passing Formula 5',
    description: 'Kelulusan: ALP 75'
  },
  {
    value: '7',
    label: 'Passing Formula 6',
    description: 'Kelulusan: Nilai Post Test =70'
  },
  {
    value: '8',
    label: 'Passing Formula 7',
    description: 'Kelulusan: jumlah nilai post test + alp (30% post test + 70% alp) = 70'
  },
  {
    value: '9',
    label: 'Passing Formula 8',
    description: 'Kelulusan: Post test 75, ALP 75'
  }
];

const COURSE_TYPE = [
  {
    value: '1',
    label: 'External'
  },
  {
    value: '2',
    label: 'In-House'
  },
  {
    value: '3',
    label: 'Internal'
  }
];

const YES_NO_OPTION = [
  {
    value: '1',
    label: 'No'
  },
  {
    value: '2',
    label: 'Yes'
  }
];
const labelMapping: Record<string, string> = {
  courseName: 'Course Name',
  courseCode: 'Course Code',
  courseCategory: 'Course Category',
  competencyCategory: 'Competency Category',
  description: 'Description',
  courseType: 'Course Type',
  modeOfDelivery: 'Mode of Delivery',
  waReminder: 'WA Reminder',
  targetAudience: 'Target Audience',
  programCategory: 'Program Category',
  specificJobBand: 'Specific Job Band',
  learningContent: 'Learning Content',
  levelOfTraining: 'Level of Training',
  learningFormat: 'Learning Format',
  trainingType: 'Training Type',
  fieldOrganizer: 'Field Organizer',
  room: 'Room',
  trainingLocation: 'Training Location',
  weightPreTest: 'Weight Pre-Test',
  weightPostTest: 'Weight Post-Test',
  weightALP: 'Weight ALP',
  weightAttendance: 'Weight Attendance',
  deliveryType: 'Delivery Type',
  learningObjectives: 'Learning Objectives',
  groupTrainingType: 'Group Training Type',
  learningHours: 'Learning Hours',
  limIndicator: 'LIM Indicator',
  liaIndicator: 'LIA Indicator',
  passingFormula: 'Passing Formula',
  creatorCode: 'Creator Code',
  businessUnits: 'Business Units',
  targetBinusian: 'Target Binusian',
  bcldLevel: 'BCLD Level',
  bcldStreamOrFunda: 'Compulsory or Optional',
  grpTraining: 'Group Training'
};

const fieldToSectionMap: Record<string, string> = {
  // Basic Information fields
  courseName: 'basicInformation',
  courseCode: 'basicInformation',
  courseCategory: 'basicInformation',
  description: 'basicInformation',
  tags: 'basicInformation',

  // BCLD Custom Field fields
  courseType: 'bcldCustomField',
  competencyCategory: 'bcldCustomField',
  targetAudience: 'bcldCustomField',
  programCategory: 'bcldCustomField',
  specificJobBand: 'bcldCustomField',
  trainingLocation: 'bcldCustomField',
  learningObjectives: 'bcldCustomField',
  learningContent: 'bcldCustomField',
  learningHours: 'bcldCustomField',
  levelOfTraining: 'bcldCustomField',
  fieldOrganizer: 'bcldCustomField',
  room: 'bcldCustomField',
  passingFormula: 'bcldCustomField',
  weightAttendance: 'bcldCustomField',
  weightPreTest: 'bcldCustomField',
  weightPostTest: 'bcldCustomField',
  weightALP: 'bcldCustomField',

  // Delivery Details fields
  deliveryType: 'deliveryDetails',
  modeOfDelivery: 'deliveryDetails',
  groupTrainingType: 'deliveryDetails',
  learningFormat: 'deliveryDetails',

  // Indicator Standard fields
  limIndicator: 'indicatorStandard',
  liaIndicator: 'indicatorStandard',

  // Activity fields
  activities: 'activity',

  // Review Approval fields
  flagReviewSME: 'reviewApproval',
  smeInternal: 'reviewApproval',
  smeExternal: 'reviewApproval',
  picApproval1: 'reviewApproval',
  picApproval2: 'reviewApproval'
};

export {
  GROUP_TRAINING_TYPE,
  LEVEL_OF_TRAINING,
  LEARNING_FORMAT,
  LEARNING_TYPE,
  MODE_OF_DELIVERY,
  PASSING_FORMULA,
  YES_NO_OPTION,
  COURSE_TYPE,
  labelMapping,
  fieldToSectionMap
};
